// Api End Point
export const URL = 'season/'
export const MODEL = 'Season'

// Incoming Start and End date format
export const DATE_FORMAT = 'YYYY-MM-DD'

// Model Properties
export const PROP_ID = 'id'
export const PROP_SEASON_ID = PROP_ID
export const PROP_LABEL = 'label'
export const PROP_START_DATE = 'startDate'
export const PROP_END_DATE = 'endDate'
export const PROP_PREVIOUS = 'previous'
